<div>
<motif-modal-title variant="alt">
    <h3>Surveys export</h3>
    <button motifIconButton aria-label="Close modal" [motif-modal-close]="true"
            [size]="ButtonSizes.LARGE">
      <motif-icon class="motif-modal-header-close-icon" [iconFunction]="IconoirXmark"></motif-icon>
    </button>
  </motif-modal-title>
  <motif-modal-content>
    <p>Please select a date range and agent to download the data.</p>
    <div style="padding: 14px">
  
      <motif-form-field>
        <label motifLabel>Date</label>
        <input name="dateSingle" [formControl]="dateSingleFormControl" [motifDatePicker]="dateSingle" placeholder="Select date"
               [motifDatePickerTrigger]="dateSingle" [selectMode]="'range'"/>
        <motif-date-picker #dateSingle>
        </motif-date-picker>
    </motif-form-field>
      <motif-form-field>
        <label motifLabel class="select-label">Select</label>
        <motif-select
          aria-label="Please select an option"
          [disabled]="false"
          placeholder="Select agent"
          searchPlaceholder="undefined"
          [selectTitle]=""
          labelPosition="undefined"
          [formControl]="selectAgentFormControl"
        >
          <motif-option value="tbe">Agent 1</motif-option>
          <motif-option value="coa">Agent 2</motif-option>
          <motif-option value="ad">Agent 5</motif-option>
        </motif-select>
        <motif-message>This is a hint text to help users</motif-message>
      </motif-form-field>
    </div>
  </motif-modal-content>
  <!-- <motif-modal-actions>
    <button
      motifButton
      color="secondary"
      variant="stepper"
      [motif-modal-close]="true"
      aria-label="Back"
      role="button"
      [motif-tooltip]="'Button Back'"
      placement="bottom"
    >
      <motif-icon [iconFunction]="IconoirNavArrowLeft"></motif-icon>
      Back
    </button>
  
    <button
      motifButton
      color="secondary"
      class="left-margin"
      variant="stepper"
      motif-modal-close
      aria-label="Next"
      role="button"
      [motif-tooltip]="'Button Next'"
    >
      Next
      <motif-icon [iconFunction]="IconoirNavArrowRight"></motif-icon>
    </button>
  </motif-modal-actions> -->

  <button motifButton (click)="onSurveyExport()">Download</button>

</div>
